import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import FileUploader from "../../Components/FileUpload/FileUpload";
import Input from "../../Components/input/input";
import TaskGridLookup, {
  toRelatedItems,
} from "../../Components/Lookup/IncidentLookUp";
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { ChangeData } from "../../utils/Change/changeTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { useFetchFullName } from "./Hooks/useFetchFullName";
import { Incident, initialIncident } from "./Incident";
import TextArea from "../../Components/TextArea/TextArea";
import ses from "../../Assets/ses.jpg";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import Bcom from "./BCom.png";
import { ProblemData } from "../../utils/Problem/problemTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { authFetch } from "../../utils/Security/authFetch";
import { joinMulti } from "../../utils/multiValue";
import { PETROBRAS_EMAILS, isPetrobrasCustomer } from "../../utils/Incident/incidentHandlers";
import Button from "../../Components/button/button";
import { getSignatureLines } from "../../utils/emailSignature";

const IncidentAdd: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isForNilesat = localStorage.getItem("isForNilesat") === "true";

  const username = localStorage.getItem("username");
  const organization = localStorage.getItem("organization") || undefined;
  console.log("orangization", organization);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isForTelebras = localStorage.getItem("isForTelebras") === "true";
  const isForPetrobras = localStorage.getItem("isForPetrobras") === "true";

  const isUser = localStorage.getItem("isUser") === "true";
  const [incident, setIncident] = useState<Incident>(initialIncident);
  const [showUserDialog, setShowUserDialog] = useState(false);
  const [customer, setCustomer] = useState<
      string | number | (string | number)[] | null
  >(null);
  const [emails, setEmails] = useState<[]>();
  const [msoEmails, setMsoEmails] = useState<string[] | undefined>(undefined);
  const email = localStorage.getItem("email");
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const navigate = useNavigate();
  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<
      (
          | TaskData
          | ChangeData
          | RmaData
          | KnowledgeBaseData
          | ProblemData
          | IncidentData
          )[]
  >([]);
  const [network, setNetwork] = useState<
      string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
      string | number | (string | number)[] | null
  >(null);

  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);

  const handleTaskSelect = (
      tasks: (
          | TaskData
          | ChangeData
          | RmaData
          | KnowledgeBaseData
          | ProblemData
          | IncidentData
          )[],
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId);
    handleChange("relatedobject", ticketIds);
    setSelectedTask(tasks);
  };
  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedPosition = localStorage.getItem("position") ?? "";
    if (storedUsername) {
      setIncident((prev) => ({
        ...prev,
        createdby: storedUsername,
        responsiblePerson: storedUsername,
        responsibleTeam: storedPosition,
      }));
    }
  }, []);
  useEffect(() => {
    //console.log("organizationnnnnnnnnnnnn", organization);
    const { urgency, impact } = incident;
    if (!urgency || !impact) return;

    const key = `${urgency}-${impact}`;
    let priority = "";
    //console.log("${urgency}-${impact}", urgency, impact);
    if (key === "Critical-Critical") priority = "Critical";
    else if (
        key === "Critical-High" ||
        key === "High-High" ||
        key === "High-Critical"
    )
      priority = "High";
    else if (
        key === "Critical-Medium" ||
        key === "High-Medium" ||
        key === "Medium-High" ||
        key === "Medium-Medium" ||
        key === "Medium-Critical"
    )
      priority = "Medium";
    else if (
        key === "Low-Low" ||
        key === "Low-High" ||
        key === "Low-Medium" ||
        key === "Low-Critical"
    )
      priority = "Low";
    else if (
        key === "Medium-Low" ||
        key === "High-Low" ||
        key === "Critical-Low"
    )
      priority = "Low";
    setIncident((prev) => ({
      ...prev,
      priority,
    }));
  }, [incident.urgency, incident.impact]);
  useFetchFullName((fullName: string) => {
    setIncident((prev) => ({ ...prev, user: fullName }));
  });
  useEffect(() => {
    if (isAdmin && isForTelebras) {
      handleChange("affectedCustomer", ["Telebras"]);
    }
    if (isAdmin && isForPetrobras) {
      handleChange("affectedCustomer", ["isForPetrobras"]);
    }
    if (isAdmin && isForNilesat) {
      handleChange("affectedCustomer", ["Nilesat"]);
    }
  }, [isAdmin, isForTelebras , isForPetrobras, isForNilesat]);


  const handleChange = (field: keyof Incident, value: any) => {
    const start = incident.incidentStartDatetime
        ? new Date(incident.incidentStartDatetime)
        : null;

    const end = value ? new Date(value) : null;

    // If user changes the START date
    if (field === "incidentStartDatetime") {
      if (incident.incidentCloseDatetime) {
        const currentEnd = new Date(incident.incidentCloseDatetime);

        // If start becomes later than end → auto-fix end
        if (currentEnd < new Date(value)) {
          setIncident((prev) => ({
            ...prev,
            incidentStartDatetime: value,
            incidentCloseDatetime: value, // auto-correct end = start
          }));
          return;
        }
      }
    }

    // If user changes the END date
    if (field === "incidentCloseDatetime") {
      if (start && end && end < start) {
        // auto-correct end = start
        setIncident((prev) => ({
          ...prev,
          incidentCloseDatetime: incident.incidentStartDatetime,
        }));
        return;
      }
    }
    setIncident((prev) => ({ ...prev, [field]: value }));
  };
  const validateForm = (): boolean => {
    if (!incident) {
      alert("Incident data is not available.");
      return false;
    }

    const requiredFields: (keyof Incident)[] = [
      "incidentStartDatetime",
      "category",
      "urgency",
      "summary",
      "description",
    ];

    for (const field of requiredFields) {
      const value = incident[field];
      if (
          value === undefined ||
          value === null ||
          value.toString().trim() === ""
      ) {
        alert(`Please fill the required field`);
        return false;
      }
    }
    if (incident.customerInformed === null && isAdmin && !isForTelebras && !isForNilesat) {
      alert("Please select whether the customer is informed (Yes or No)");
      return false;
    }

    return true;
  };
  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const response = await authFetch(
            `${config.apiBaseUrl}/api/responsible-person/emails/role2`,
        );
        if (!response.ok) {
          throw new Error("Failed to fetch emails");
        }
        const data = await response.json();

        const allEmails = [...data];
        const uniqueEmails = Array.from(new Set(allEmails)); // remove duplicates
        setMsoEmails(uniqueEmails);
        //console.log("emailssssssssssssss", uniqueEmails);
      } catch (err: any) {
        console.error("Email fetch failed:", err);
      } finally {
        // Optional: you can handle loading state here
      }
    };

    fetchEmails();
  }, []);

  const handleSubmit = async () => {
    if (isSubmitting) return; // 🚫 prevent double-click
    if (!validateForm()) return;

    setIsSubmitting(true); // ⏳ lock button

    const updatedIncident: Incident = {
      ...incident,
      customerInformed: isAdmin ? incident.customerInformed : true,
      affectedSite:
          isallsite === "true" ? ["All Sites"] : incident.affectedSite,
      affectedLink:
          isalllink === "true" ? ["All Links"] : incident.affectedLink,
      affectedNetwork:
          isallnetwork === "true" ? ["All Networks"] : incident.affectedNetwork,
    };

    const formattedDate = updatedIncident.incidentStartDatetime.replace(
        "T",
        " ",
    );
    const formattedDateClose = updatedIncident.incidentCloseDatetime.replace(
        "T",
        " ",
    );

    //console.log("Submitting Incident:", updatedIncident);

    try {
      const response = await authFetch(`${config.apiBaseUrl}/api/incidents`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedIncident),
      });

      const savedIncident = await response.json();
      updatedIncident.ticketId = savedIncident.ticketId;
      // Petrobras: customer-informed emails go only to the Petrobras list
      const customerEmails = isPetrobrasCustomer(updatedIncident.affectedCustomer)
          ? PETROBRAS_EMAILS
          : emails;
      if (updatedIncident.customerInformed && isAdmin) {
        const payload = {
          to: customerEmails,

          subject: `An incident with ID ${updatedIncident.ticketId} has been Opened.`,
          body: `
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
        <p>Hello,</p>
        <p>A ticket with ID ${
              updatedIncident.ticketId
          } has been opened with the following comment</p>
        <p><strong>Customer:</strong> ${
              updatedIncident.affectedCustomer
          }<br><br>
      <strong>Network:</strong> ${updatedIncident.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${updatedIncident.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${updatedIncident.affectedLink ?? ""}<br><br>
        <strong>Incident Start Date:</strong> ${formattedDate}<br><br>
        <strong>Incident Close Date:</strong> ${formattedDateClose}<br><br><br>
        <strong>Summary:</strong> ${updatedIncident.summary}<br><br>
        <strong>Description:</strong> ${updatedIncident.description}<br><br>
        <strong>Error Type:</strong> ${updatedIncident.errorType}<br><br>
        <strong>Closure Code:</strong> ${updatedIncident.closureCode}<br><br>
        <strong>Solution:</strong> ${updatedIncident.solution}</p><br>
         <p>
                 <p>Regards,<br><br></p>

     <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Incident Details
              </a>
    </p>

     <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(updatedIncident.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
    `,
        };

        try {
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          localStorage.setItem("email", updatedIncident.email);
        } catch (emailErr) {
          console.error("❌ Failed to send email notification:", emailErr);
        }
      } else if (!isAdmin) {
        const siteInfo =
            isallsite === "true"
                ? "All Sites"
                : (updatedIncident.affectedSite ?? "");
        const linkInfo =
            isalllink === "true"
                ? "All Links"
                : (updatedIncident.affectedLink ?? "");
        const networkInfo =
            isallnetwork === "true"
                ? "All Networks"
                : (updatedIncident.affectedNetwork ?? "");
        console.log(
            "djjdjdjdjjjdjdjjdjdjdjdjdjdj",
            siteInfo,
            linkInfo,
            networkInfo,
        );
        const email = msoEmails;
        const subject = `An incident with ID ${updatedIncident.ticketId} has been Opened.`;
        const body = `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>
      <p>A ticket with ID ${
            updatedIncident.ticketId
        } has been opened with the following comment</p>
      <p><strong>Customer:</strong> ${updatedIncident.affectedCustomer}<br><br>
        <strong>Network:</strong> ${
            updatedIncident.affectedNetwork ?? ""
        }<br><br>
      <strong>Site:</strong> ${updatedIncident.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${updatedIncident.affectedLink ?? ""}<br><br>
      <strong>Incident Start Date:</strong> ${formattedDate}<br><br>
      <strong>Incident Close Date:</strong> ${formattedDateClose}<br><br><br>
      <strong>Summary:</strong> ${updatedIncident.summary}<br><br>
      <strong>Description:</strong> ${updatedIncident.description}<br><br>
      <strong>Error Type:</strong> ${updatedIncident.errorType}<br><br>
      <strong>Closure Code:</strong> ${updatedIncident.closureCode}<br><br>
      <strong>Solution:</strong> ${updatedIncident.solution}</p>
      <p>
            <p>Regards,<br><br></p>
 <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Incident Details
              </a>
    </p>

     <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(updatedIncident.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `;

        try {
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to: customerEmails, subject, body }),
          });
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to: msoEmails, subject, body }),
          });

          localStorage.setItem("email", updatedIncident.email);
        } catch (emailErr) {
          console.error("Failed to send email notifications:", emailErr);
        }
      } else if (
          isAdmin &&
          (updatedIncident.affectedCustomer.includes("Conecel") ||
              updatedIncident.affectedCustomer.includes("Claro Nicaragua"))
      ) {
        const email = ["Maria.valle@ses.com"];
        const payload = {
          to: email,
          subject: `An incident with ID ${updatedIncident.ticketId} has been Opened.`,
          body: `
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
        <p>Hello,</p>
        <p>A ticket with ID ${
              updatedIncident.ticketId
          } has been opened with the following comment</p>
        <p><strong>Customer:</strong> ${
              updatedIncident.affectedCustomer
          }<br><br>
       <strong>Network:</strong> ${
              updatedIncident.affectedNetwork ?? ""
          }<br><br>
      <strong>Site:</strong> ${updatedIncident.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${updatedIncident.affectedLink ?? ""}<br><br>
        <strong>Incident Start Date:</strong> ${formattedDate}<br><br>
        <strong>Incident Close Date:</strong> ${formattedDateClose}<br><br><br>
        <strong>Summary:</strong> ${updatedIncident.summary}<br><br>
        <strong>Description:</strong> ${updatedIncident.description}<br><br>
        <strong>Error Type:</strong> ${updatedIncident.errorType}<br><br>
        <strong>Closure Code:</strong> ${updatedIncident.closureCode}<br><br>
        <strong>Solution:</strong> ${updatedIncident.solution}</p><br>
         <p>
    <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Incident Details
              </a>
    </p>

     <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(updatedIncident.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
    `,
        };

        try {
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          localStorage.setItem("email", updatedIncident.email);
        } catch (emailErr) {
          console.error("❌ Failed to send email notification:", emailErr);
        }
      }

      if (
          updatedIncident.customerComplaint &&
          updatedIncident.affectedCustomer.includes("Claro Nicaragua")
      ) {
        const complaintPayload = {
          to: [
            "b.valle@bcomsat.com",
            "r.mdazevedo@bcomsat.com",
            "Y.gutierrez@bcomsat.com",
          ],
          subject: `Customer Complaint - Incident ID ${updatedIncident.ticketId}`,
          body: `
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
        <p>Hello,</p>
        <p>A ticket with ID ${
              updatedIncident.ticketId
          } has been opened with the following comment</p>
        <p><strong>Customer:</strong> ${
              updatedIncident.affectedCustomer
          }<br><br>
       <strong>Network:</strong> ${
              updatedIncident.affectedNetwork ?? ""
          }<br><br>
      <strong>Site:</strong> ${updatedIncident.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${updatedIncident.affectedLink ?? ""}<br><br>
        <strong>Incident Start Date:</strong> ${formattedDate}<br><br>
        <strong>Incident Close Date:</strong> ${formattedDateClose}<br><br><br>
        <strong>Summary:</strong> ${updatedIncident.summary}<br><br>
        <strong>Description:</strong> ${updatedIncident.description}<br><br>
        <strong>Error Type:</strong> ${updatedIncident.errorType}<br><br>
        <strong>Closure Code:</strong> ${updatedIncident.closureCode}<br><br>
        <strong>Solution:</strong> ${updatedIncident.solution}</p><br>
         <p>
     <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Incident Details
              </a>
    </p>

     <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(updatedIncident.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
      </div>
    `,
        };

        try {
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(complaintPayload),
          });
          console.log("✅ Customer complaint email sent to Jackson.");
        } catch (emailErr) {
          console.error("❌ Failed to send complaint email:", emailErr);
        }
      }
      if (
          updatedIncident.customerComplaint &&
          updatedIncident.affectedCustomer.includes("Conecel")
      ) {
        const complaintPayload = {
          to: ["b.valle@bcomsat.com", "r.tuyama@bcomsat.com"],
          subject: `Customer Complaint - Incident ID ${updatedIncident.ticketId}`,
          body: `
  <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
    <p>Hello,</p>
    <p>A ticket with ID ${
              updatedIncident.ticketId
          } has been opened with the following comment</p>

    <p><strong>Customer:</strong> ${updatedIncident.affectedCustomer}<br><br>
    <strong>Network:</strong> ${updatedIncident.affectedNetwork ?? ""}<br><br>
    <strong>Site:</strong> ${updatedIncident.affectedSite ?? ""}<br><br>
    <strong>Link:</strong> ${updatedIncident.affectedLink ?? ""}<br><br>
    <strong>Incident Start Date:</strong> ${formattedDate}<br><br>
    <strong>Incident Close Date:</strong> ${formattedDateClose}<br><br><br>
    <strong>Summary:</strong> ${updatedIncident.summary}<br><br>
    <strong>Description:</strong> ${updatedIncident.description}<br><br>
    <strong>Error Type:</strong> ${updatedIncident.errorType}<br><br>
    <strong>Closure Code:</strong> ${updatedIncident.closureCode}<br><br>
    <strong>Solution:</strong> ${updatedIncident.solution}</p><br>
 <p>
   <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                   👉 View Incident Details
                 </a>
       </p>
   
        <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
         <tr>
           <td style="vertical-align: top; padding-right: 12px;">
   
            <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
         
   
           </td>
   
           <td>
             <div style="
               padding: 12px;
               border-left: 4px solid #2a1364;
               background-color: #f9f9f9;
               color: #2a1364;
               font-size: 13px;
             ">
               <strong>Managed Services Operations</strong><br>
               ${getSignatureLines(updatedIncident.affectedCustomer, "#2a1364")}
             </div>
           </td>
         </tr>
       </table>
  </div>
`,
        };

        try {
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(complaintPayload),
          });
          console.log("✅ Customer complaint email sent to Jackson.");
        } catch (emailErr) {
          console.error("❌ Failed to send complaint email:", emailErr);
        }
      }
      if (!response.ok) throw new Error("Failed to submit incident");
      if (updatedIncident.customerInformed && !isAdmin) {
        alert("Incident submitted successfully.");
      } else if (updatedIncident.customerInformed && isAdmin) {
        alert("Incident submitted successfully and customer informed.");
      } else {
        // customer is not informed, admin or not
        alert("Incident submitted successfully and customer is not informed.");
      }
      setIncident({ ...initialIncident, ticketId: updatedIncident.ticketId });
      navigate("/incident", { state: { updatedIncident: savedIncident } });
    } catch (error) {
      alert(`Submission error: ${(error as Error).message}`);
      console.error(`Submission error: ${(error as Error).message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!incident.ticketId) {
      const randomId = `IND${Math.floor(10000 + Math.random() * 90000)}`;
      setIncident((prev) => ({ ...prev, ticketId: randomId }));
    }
  }, []);

  type ValType = string | number | (string | number)[] | null | undefined;

  const fetchCustomerData = async (val: ValType) => {
    try {
      let orgValue: string | number | (string | number)[];

      if (val === null || val === undefined) {
        orgValue = organization ?? "";
      } else {
        orgValue = val;
      }

      let orgQueryParam = "";

      if (Array.isArray(orgValue)) {
        orgQueryParam = orgValue
            .map((item) => encodeURIComponent(String(item)))
            .join(",");
      } else {
        orgQueryParam = encodeURIComponent(String(orgValue));
      }

      const responseIds = await authFetch(
          `${config.apiBaseUrl}/api/users/id-by-organization?organization=${orgQueryParam}`,
      );
      if (!responseIds.ok)
        throw new Error(`HTTP error! status: ${responseIds.status}`);

      const userIds = await responseIds.json();

      const userIdsParam = Array.isArray(userIds) ? userIds.join(",") : userIds;

      const responseEmails = await authFetch(
          `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
      );
      if (!responseEmails.ok)
        throw new Error(`HTTP error! status: ${responseEmails.status}`);

      const emails = await responseEmails.json();

      setEmails(emails);

      handleChange("foruserid", userIds);

      if (Array.isArray(val) && val.length === 0) {
        handleChange("affectedCustomer", [organization]);
      } else {
        handleChange("affectedCustomer", [val]);
      }
    } catch (error) {
      console.error("Failed to fetch customer or emails:", error);
    }
  };
  useEffect(() => {
    if (isAdmin && isForTelebras) {
      const fetchData = async () => {
        try {
          console.log("API CALLED");

          const responseIds = await authFetch(
              `${config.apiBaseUrl}/api/users/id-by-organization?organization=Telebras`,
          );

          if (!responseIds.ok) throw new Error("Failed");

          const userIds = await responseIds.json();

          const userIdsParam = Array.isArray(userIds)
              ? userIds.join(",")
              : userIds;

          const responseEmails = await authFetch(
              `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
          );

          const emails = await responseEmails.json();

          setEmails(emails);

          handleChange("foruserid", userIds);
          handleChange("affectedCustomer", ["Telebras"]);
        } catch (error) {
          console.error(error);
        }
      };

      fetchData();
    }
  }, [isAdmin, isForTelebras]);

  useEffect(() => {
    if (isAdmin && isForPetrobras) {
      const fetchData = async () => {
        try {
          console.log("API CALLED");

          const responseIds = await authFetch(
              `${config.apiBaseUrl}/api/users/id-by-organization?organization=Petrobras`,
          );

          if (!responseIds.ok) throw new Error("Failed");

          const userIds = await responseIds.json();

          const userIdsParam = Array.isArray(userIds)
              ? userIds.join(",")
              : userIds;

          const responseEmails = await authFetch(
              `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
          );

          const emails = await responseEmails.json();

          setEmails(emails);

          handleChange("foruserid", userIds);
          handleChange("affectedCustomer", ["Petrobras"]);
        } catch (error) {
          console.error(error);
        }
      };

      fetchData();
    }


  }, [isAdmin, isForPetrobras]);
  useEffect(() => {
    if (isAdmin && isForNilesat) {
      const fetchData = async () => {
        try {
          const responseIds = await authFetch(
              `${config.apiBaseUrl}/api/users/id-by-organization?organization=Nilesat`,
          );

          if (!responseIds.ok) throw new Error("Failed");

          const userIds = await responseIds.json();

          const userIdsParam = Array.isArray(userIds)
              ? userIds.join(",")
              : userIds;

          const responseEmails = await authFetch(
              `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
          );

          const emails = await responseEmails.json();

          setEmails(emails);

          handleChange("foruserid", userIds);
          handleChange("affectedCustomer", ["Nilesat"]);
        } catch (error) {
          console.error(error);
        }
      };

      fetchData();
    }
  }, [isAdmin, isForNilesat]);

  useEffect(() => {
    if (organization && !isForTelebras && !isForPetrobras && !isForNilesat) {
      fetchCustomerData(organization);
    }
  }, [organization]);

  return (
      <div className="incident-form">
        <section className="form-section">
          <h3>Incident Information</h3>
          <div className="grid">
            <Input
                type="text"
                label="Created By"
                value={incident.createdby ?? ""}
                onChange={(val) => handleChange("createdby", val)}
                readOnly
            />
            {isAdmin && (
                <ApiDropdown
                    api="users/fullnames"
                    labelKey="fullName"
                    valueKey="id"
                    label="User"
                    onChange={async (val) => {
                      handleChange("userid", val);
                      try {
                        const res = await authFetch(
                            `${config.apiBaseUrl}/api/users/${val}`,
                        );
                        if (!res.ok) throw new Error("User not found");
                        const user = await res.json();
                        handleChange("email", user.email);
                      } catch (err) {
                        console.error("Error fetching user:", err);
                      }
                    }}
                />
            )}
            {!isAdmin && (
                <ApiDropdown
                    api={`users/by-organization/${organization}`}
                    labelKey="username"
                    valueKey="id"
                    label="User"
                    onChange={async (val) => {
                      handleChange("userid", val);
                      try {
                        const res = await authFetch(
                            `${config.apiBaseUrl}/api/users/${val}`,
                        );
                        if (!res.ok) throw new Error("User not found");
                        const user = await res.json();
                        handleChange("email", user.email);
                      } catch (err) {
                        console.error("Error fetching user:", err);
                      }
                    }}
                />
            )}

            <Input
                readOnly
                type="text"
                label="Ticket ID"
                value={incident.ticketId || ""}
                onChange={() => {}}
            />

            <Input
                type="datetime-local"
                label="Incident Start Date/Time (UTC)"
                required={true}
                value={incident.incidentStartDatetime}
                onChange={(val) => handleChange("incidentStartDatetime", val)}
            />
            {isAdmin && (
                <Input
                    type="text"
                    label="Incident Cross Reference "
                    value={incident.incidentCrossReference}
                    onChange={(val) => handleChange("incidentCrossReference", val)}
                />
            )}
            {isAdmin && (
                <>
                  <div className="radio-group">
                    <label className="required-label">Customer Informed *</label>

                    <div style={{ display: "flex", gap: "20px" }}>
                      <label>
                        <input
                            type="radio"
                            name="customerInformed"
                            value="yes"
                            checked={incident.customerInformed === true}
                            onChange={() => handleChange("customerInformed", true)}
                        />
                        Yes
                      </label>

                      <label>
                        <input
                            type="radio"
                            name="customerInformed"
                            value="no"
                            checked={incident.customerInformed === false}
                            onChange={() => handleChange("customerInformed", false)}
                        />
                        No
                      </label>
                    </div>
                  </div>
                  <Checkbox
                      label="Customer Complaint"
                      onChange={(e) =>
                          handleChange("customerComplaint", e.target.checked)
                      }
                      checked={incident.customerComplaint}
                  />
                </>
            )}
          </div>
        </section>

        <section className="form-section">
          <h3>Customer & Network</h3>
          <div className="grid">
            {!isAdmin && !isForTelebras && !isForPetrobras && !isForNilesat && (
                <ApiDropdown
                    api="affected-customers"
                    required={true}
                    labelKey="customername"
                    disabled
                    value={organization}
                    valueKey="customername"
                    label="Customer"
                    isMulti
                    onOpen={async () => {
                      try {
                        console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");

                        const responseIds = await authFetch(
                            `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`,
                        );
                        if (!responseIds.ok)
                          throw new Error(
                              `HTTP error! status: ${responseIds.status}`,
                          );
                        const userIds = await responseIds.json();

                        const userIdsParam = Array.isArray(userIds)
                            ? userIds.join(",")
                            : userIds;
                        const responseEmails = await authFetch(
                            `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                        );
                        if (!responseEmails.ok)
                          throw new Error(
                              `HTTP error! status: ${responseEmails.status}`,
                          );
                        const emails = await responseEmails.json();
                        setEmails(emails);
                        //console.log("Fetched emails:", emails);

                        handleChange("foruserid", userIds);

                        handleChange("affectedCustomer", [organization]);
                      } catch (error) {
                        console.error("Failed to fetch customer or emails:", error);
                      }
                    }}
                />
            )}
            {isAdmin && !isForTelebras && !isForPetrobras  && !isForNilesat &&(
                <ApiDropdown
                    api="affected-customers"
                    labelKey="customername"
                    required={true}
                    valueKey="customername"
                    label="Customer"
                    isMulti
                    onChange={async (val) => {
                      setCustomer(val);
                      handleChange("affectedCustomer", val);
                      try {
                        const responseIds = await authFetch(
                            `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`,
                        );
                        if (!responseIds.ok)
                          throw new Error(
                              `HTTP error! status: ${responseIds.status}`,
                          );
                        const userIds = await responseIds.json();
                        //console.log("Fetched user IDs:", userIds);

                        const userIdsParam = Array.isArray(userIds)
                            ? userIds.join(",")
                            : userIds;
                        const responseEmails = await authFetch(
                            `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                        );
                        if (!responseEmails.ok)
                          throw new Error(
                              `HTTP error! status: ${responseEmails.status}`,
                          );
                        const emails = await responseEmails.json();
                        setEmails(emails);
                        //console.log("Fetched emails:", emails);

                        handleChange("foruserid", userIds);
                      } catch (error) {
                        console.error("Failed to fetch customer or emails:", error);
                      }
                    }}
                />
            )}
            {isAdmin && isForTelebras && (
                <ApiDropdown
                    api="affected-customers"
                    required
                    labelKey="customername"
                    valueKey="customername"
                    label="Customer"
                    value={"Telebras"}
                    disabled
                />
            )}
            {isAdmin && isForPetrobras && (
                <ApiDropdown
                    api="affected-customers"
                    required
                    labelKey="customername"
                    valueKey="customername"
                    label="Customer"
                    value={"Petrobras"}
                    disabled
                />
            )}
            {isAdmin && isForNilesat && (
                <ApiDropdown
                    api="affected-customers"
                    required
                    labelKey="customername"
                    valueKey="customername"
                    label="Customer"
                    value={"Nilesat"}
                    disabled
                />
            )}
            {!isAdmin && organization && (
                <ApiDropdown
                    api={`everything/networks?customer=${organization}`}
                    labelKey="label"
                    valueKey="value"
                    label=" Networks"
                    required={true}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleChange("affectedNetwork", val);
                    }}
                />
            )}
            {isAdmin && isForTelebras && (
                <ApiDropdown
                    api={`everything/networks?customer=Telebras`}
                    labelKey="label"
                    valueKey="value"
                    label=" Networks"
                    required={true}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleChange("affectedNetwork", val);
                    }}
                />
            )}
            {isAdmin && isForNilesat && (
                <ApiDropdown
                    api={`everything/networks?customer=Nilesat`}
                    labelKey="label"
                    valueKey="value"
                    label=" Networks"
                    required={true}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleChange("affectedNetwork", val);
                    }}
                />
            )}
            {isAdmin && isForPetrobras && (
                <ApiDropdown
                    api={`everything/networks?customer=Petrobras`}
                    labelKey="label"
                    valueKey="value"
                    label=" Networks"
                    required={true}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleChange("affectedNetwork", val);
                    }}
                />
            )}
            {!isAdmin && organization && (
                <>
                  {network && (
                      <ApiDropdown
                          api={`everything/sites?customer=${organization}&network=${network}`}
                          labelKey="label"
                          valueKey="value"
                          label=" Site"
                          isMulti
                          onChange={(val) => {
                            setSite(val);
                            handleChange("affectedSite", val);
                          }}
                      />
                  )}

                  {site && (
                      <ApiDropdown
                          api={`everything/links?customer=${organization}&network=${network}&site=${site}`}
                          labelKey="label"
                          valueKey="value"
                          label=" Link"
                          isMulti
                          onChange={(val) => handleChange("affectedLink", val)}
                      />
                  )}

                  <ApiDropdown
                      api={`everything/asset?customer=${organization}&network=${network}`}
                      labelKey="label"
                      valueKey="value"
                      label="Assets"
                      isMulti
                      onChange={(val) => handleChange("asset", joinMulti(val))}
                  />
                </>
            )}

            {isAdmin && (
                <>
                  {customer && (
                      <ApiDropdown
                          api={`everything/networks?customer=${customer}`}
                          labelKey="label"
                          valueKey="value"
                          required={true}
                          label="Networks"
                          isMulti
                          onChange={(val) => {
                            setNetwork(val);
                            handleChange("affectedNetwork", val);
                          }}
                      />
                  )}

                  {network &&  !isForTelebras &&!isForPetrobras && !isForNilesat &&(
                      <ApiDropdown
                          api={`everything/sites?customer=${customer}&network=${network}`}
                          labelKey="label"
                          valueKey="value"
                          label="Site"
                          isMulti
                          onChange={(val) => {
                            setSite(val);
                            handleChange("affectedSite", val);
                          }}
                      />
                  )}
                  {network &&  isForTelebras &&(
                      <ApiDropdown
                          api={`everything/sites?customer=Telebras&network=${network}`}
                          labelKey="label"
                          valueKey="value"
                          label="Site"
                          isMulti
                          onChange={(val) => {
                            setSite(val);
                            handleChange("affectedSite", val);
                          }}
                      />
                  )}
                  {network && isForNilesat && (
                      <ApiDropdown
                          api={`everything/sites?customer=Nilesat&network=${network}`}
                          labelKey="label"
                          valueKey="value"
                          label="Site"
                          isMulti
                          onChange={(val) => {
                            setSite(val);
                            handleChange("affectedSite", val);
                          }}
                      />
                  )}
                  {network && isForPetrobras && (
                      <ApiDropdown
                          api={`everything/sites?customer=Petrobras&network=${network}`}
                          labelKey="label"
                          valueKey="value"
                          label="Site"
                          isMulti
                          onChange={(val) => {
                            setSite(val);
                            handleChange("affectedSite", val);
                          }}
                      />
                  )}

                  {site &&
                      !isForTelebras && !isForPetrobras  && !isForNilesat &&(
                          <ApiDropdown
                              api={`everything/links?customer=${customer}&network=${network}&site=${site}`}
                              labelKey="label"
                              valueKey="value"
                              label="Link"
                              isMulti
                              onChange={(val) => handleChange("affectedLink", val)}
                          />
                      )}

                  {site &&
                      isForTelebras &&(
                          <ApiDropdown
                              api={`everything/links?customer=Telebras&network=${network}&site=${site}`}
                              labelKey="label"
                              valueKey="value"
                              label="Link"
                              isMulti
                              onChange={(val) => handleChange("affectedLink", val)}
                          />
                      )}
                  {site && isForNilesat && (
                      <ApiDropdown
                          api={`everything/links?customer=Nilesat&network=${network}&site=${site}`}
                          labelKey="label"
                          valueKey="value"
                          label="Link"
                          isMulti
                          onChange={(val) => handleChange("affectedLink", val)}
                      />
                  )}
                  {site && isForPetrobras && (
                      <ApiDropdown
                          api={`everything/links?customer=Petrobras&network=${network}&site=${site}`}
                          labelKey="label"
                          valueKey="value"
                          label="Link"
                          isMulti
                          onChange={(val) => handleChange("affectedLink", val)}
                      />
                  )}

                  <ApiDropdown
                      api={`everything/asset?customer=${customer}&network=${network}`}
                      labelKey="label"
                      valueKey="value"
                      label="Assets"
                      isMulti
                      onChange={(val) => handleChange("asset", joinMulti(val))}
                  />

                  <ApiDropdown
                      api={`everything/antenna?customer=${customer}`}
                      labelKey="label"
                      valueKey="value"
                      label="Antennas"
                      isMulti
                      onChange={(val) => handleChange("affectedAntenna", val)}
                  />
                </>
            )}
          </div>
        </section>

        <section className="form-section">
          <h3>Incident Severity</h3>
          <div className="grid">
            <ApiDropdown
                api="Urgencys"
                required
                labelKey="name"
                valueKey="name"
                label="Urgency"
                onChange={(val) => handleChange("urgency", val)}
            />
            {isAdmin && (
                <ApiDropdown
                    api="Impacts"
                    required
                    labelKey="name"
                    valueKey="name"
                    label="Impact"
                    onChange={(val) => handleChange("impact", val)}
                />
            )}

            {isAdmin && (
                <Input
                    readOnly
                    type="text"
                    label="Priority"
                    value={incident.priority || ""}
                    onChange={() => {}}
                />
            )}
          </div>
        </section>
        <section className="form-section">
          <h3>Incident Details</h3>
          <div className="grid2">
            <TextArea
                label="Summary"
                required={true}
                style={{
                  minHeight: "30px",
                  minWidth: "90%",
                  backgroundColor: "white",
                }}
                value={incident.summary}
                onChange={(val) => handleChange("summary", val)}
            />
            <TextArea
                label="Description"
                required={true}
                style={{
                  minHeight: "100px",
                  minWidth: "90%",
                  backgroundColor: "white",
                }}
                value={incident.description}
                onChange={(val) => handleChange("description", val)}
            />

            <ApiDropdown
                api="categories"
                required
                labelKey="name"
                valueKey="name"
                label="Category"
                onChange={(val) => handleChange("category", val)}
            />

            {/* <TextArea
            label="Journal update"
            value={incident.journalUpdate}
            onChange={(val) => handleChange("journalUpdate", val)}
          /> */}
            {/* <TextArea
            label="Communication"
            value={incident.communication}
            style={{ minHeight: "100px", minWidth: "90%" }}
            onChange={(val) => handleChange("communication", val)}
          /> */}
          </div>
        </section>

        {/* <section className="form-section">
        <h3>SLA & OLA</h3>
        <div className="grid">
          {isAdmin && (
            <>
              <Input
                type="text"
                label="OLA"
                value={incident.ola}
                onChange={(val) => handleChange("ola", val)}
              />
              <Input
                type="text"
                label="OLA Status"
                value={incident.olaStatus}
                onChange={(val) => handleChange("olaStatus", val)}
              />
            </>
          )}
        </div>
      </section> */}
        {isAdmin && (
            <section className="form-section">
              <h3>Responsibilty</h3>
              <div className="grid">
                <>
                  <Input
                      type="text"
                      label="Responsible Person"
                      value={incident.responsiblePerson}
                      onChange={(val) => handleChange("responsiblePerson", val)}
                      readOnly
                  />

                  {isAdmin && (
                      <Input
                          type="text"
                          label="Responsible Team"
                          value={incident.responsibleTeam}
                          onChange={(val) => handleChange("responsibleTeam", val)}
                          readOnly
                      />
                  )}
                </>
              </div>
            </section>
        )}
        <section className="form-section">
          <h3>Related Object</h3>
          <div className="grid">
            <FileUploader
                value={incident.filePath}
                onRemove={(path) =>
                  handleChange("filePath", (incident.filePath || []).filter((p: any) => p !== path))
                }
                onChange={async (files, paths) => {
                  if (!files || !paths.length) return;

                  const uploadedPaths: string[] = [];

                  for (let i = 0; i < files.length; i++) {
                    const safeFileName = files[i].name.replace(/\s+/g, "_");

                    // Create a new File object with the updated name
                    const renamedFile = new File([files[i]], safeFileName, {
                      type: files[i].type,
                    });

                    const formData = new FormData();
                    formData.append("file", renamedFile);

                    try {
                      const response = await authFetch(
                          `${config.apiBaseUrl}/api/incidents/upload`,
                          {
                            method: "POST",
                            body: formData,
                          },
                      );

                      if (response.ok) {
                        let { path } = await response.json();

                        // Ensure spaces are replaced with "_" before saving in DB
                        path = path.replace(/\s+/g, "_");

                        uploadedPaths.push(path);
                        console.log(
                            "jacksonnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn",
                            uploadedPaths,
                        );
                      } else {
                        console.error(`Upload failed for file: ${safeFileName}`);
                      }
                    } catch (error) {
                      console.error("Error uploading file", error);
                    }
                  }

                  if (uploadedPaths.length) {
                    handleChange("filePath", [
                      ...(incident.filePath || []),
                      ...uploadedPaths,
                    ]);
                  }
                }}
            />

            {isAdmin && !isForTelebras && !isForNilesat && (
                <>
                  <button onClick={handleOpenTaskLookup}>
                    Select Related Ticket
                  </button>
                  {selectedTask && selectedTask.length > 0 && (
                      <div>
                        <p>
                          <strong>Selected Tasks:</strong>
                        </p>
                        <ul>
                          {selectedTask.map((task, index) => (
                              <li key={index}>{task.ticketId}</li>
                          ))}
                        </ul>
                      </div>
                  )}
                  <TaskGridLookup
                      isOpen={isTaskLookupOpen}
                      onClose={handleCloseTaskLookup}
                      onSelect={handleTaskSelect}
                      selectedItems={toRelatedItems(incident.relatedobject)}
                  />{" "}
                </>
            )}
          </div>
        </section>
        <div className="submit-section">
          <Button onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit Incident"}
          </Button>
        </div>
      </div>
  );
};

export default IncidentAdd;
